export const searchShownLimit = 40;
